import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import Chart from "./Chart";

const mapStateToProps = (state: RootState) => {
    const projectedPrimaryGradingVolume = state.reviewAndPublish.shiftPlanOutput?.projectedPrimaryGradingVolume;
    const primaryGradingVolumeTotal = state.reviewAndPublish.shiftPlanOutput?.primaryGradingVolume?.recommended?.total;

    return {
        projectedPrimaryGradingVolume,
        primaryGradingVolumeTotal
    };
};

export default connect(mapStateToProps)(Chart);
